import { render, staticRenderFns } from "./AlertsConfiguredComponent.vue?vue&type=template&id=326966b5&"
import script from "./AlertsConfiguredComponent.vue?vue&type=script&lang=js&"
export * from "./AlertsConfiguredComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlertsConfiguredComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports